export default __webpack_public_path__ + "static/fininscase3-9ddb238960f1bfadbe80b0acf013fa69.png";